import React, {FC, ReactNode, useMemo} from 'react';

import {RendererOf} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {InboxModel} from '../../../../libs/shared/core/src/models/api/inboxModel';
import {
  ConjunctionRenderer,
  ItemsFormatter,
  OthersTextDecorator,
} from '../../../../srcCommon/formatters/itemsFormatter';

/*
 * Props.
 */

interface InboxesFormatterProps {
  /** The inboxes to render. */
  inboxes: ReadonlyArray<InboxModel>;
  /** The maximum number of names to display. */
  limit?: number;
  /** Render inbox name. */
  renderInboxName?: RendererOf<ReactNode>;
  /** Render "X others" text. */
  renderOthersText?: OthersTextDecorator;
  /** Render the conjunction. Defaults to "and". */
  renderConjunction?: ConjunctionRenderer;
}

/*
 * Component.
 */

export const InboxesFormatter: FC<InboxesFormatterProps> = (props) => {
  const {inboxes} = props;
  const items = useMemo(() => inboxes.map((inbox) => ({id: inbox.id, name: inbox.name})), [inboxes]);
  return (
    <ItemsFormatter
      items={items}
      limit={props.limit}
      renderName={props.renderInboxName}
      renderOthersText={props.renderOthersText}
      renderConjunction={props.renderConjunction}
    />
  );
};
